import en from "../assets/locale/en";
import nl from "../assets/locale/nl";

// nuxt.config pins PrimeVue's component locale to `nl` at install time, so paginator
// text, sort/expand aria labels and DataTable empty messages stayed Dutch for English
// users. Follow the active i18n locale instead.
type PrimeVueLocale = typeof nl;

const LOCALES: Record<string, PrimeVueLocale> = { en, nl };

export default defineNuxtPlugin((nuxtApp) => {
  const primevue = nuxtApp.vueApp.config.globalProperties.$primevue;
  const i18n = nuxtApp.$i18n as { locale?: unknown } | undefined;
  if (!primevue?.config || !i18n?.locale) return;

  const apply = (code: string) => {
    primevue.config.locale = LOCALES[code] ?? LOCALES.nl;
  };

  apply(unref(i18n.locale) as string);
  watch(() => unref(i18n.locale) as string, apply);
});
